var req = require("!!/Users/dw/Exploros/front-end/webpack/loaders/pug-template-loader.js!/Users/dw/Exploros/front-end/elements/HTMLteacher_gate/template.jade");
module.exports = (req['default'] || req).apply(req, [])